import type { MailSignature } from "../../services/mailSignatureService";

/**
 * Welche Signatur gilt für ein Absender-Postfach?
 *
 * Reihenfolge:
 *   1. Standard des gewählten Postfachs
 *   2. sonst der allgemeine Standard (ohne Postfach-Bindung)
 *   3. sonst keine
 *
 * Pur und ohne DOM — die eigentliche Einfüge-Logik liegt in `signatureDom.ts`.
 */
export function resolveSignatureForMailbox(
    signatures: MailSignature[],
    mailbox: string | null,
): MailSignature | null {
    const mb = (mailbox ?? "").trim().toLowerCase();

    // Nur EIGENE Signaturen lösen automatisch auf. Mandantenweite
    // (`scope='tenant'`) sind für alle sichtbar, gehören fachlich aber ihrem
    // Owner — dessen Standard darf nicht ungefragt in fremde Mails geraten.
    // `isOwn === true` wird strikt geprüft: Fehlt das Feld (alte Antwort, alter
    // Cache), wird NICHTS eingefügt statt womöglich das Falsche.
    const own = signatures.filter((s) => s.isOwn === true && s.isDefault);

    // Deterministischer Tie-Break als Netz gegen Altdaten, die vor dem
    // Unique-Index entstanden sein könnten: der zuletzt geänderte gewinnt.
    const byRecency = (a: MailSignature, b: MailSignature) =>
        (b.updatedAt ?? "").localeCompare(a.updatedAt ?? "") || b.id - a.id;

    if (mb) {
        const exact = own
            .filter((s) => (s.mailboxAddress ?? "").toLowerCase() === mb)
            .sort(byRecency);
        if (exact[0]) return exact[0];
    }

    // Allgemeiner Standard: keine Postfach-Bindung.
    return own.filter((s) => !(s.mailboxAddress ?? "")).sort(byRecency)[0] ?? null;
}
